import { Button, Dialog, DialogContent, Box, Avatar, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { PiWarningCircleFill, PiTrash, PiCheckCircleFill, PiCircle } from "react-icons/pi";
import { ApiRequest } from 'GlobalFunctions';

export default function CancelOrderDialog(props: any) {
    const { 
        open, 
        setOpen, 
        loading, 
        total_price,
        order_id,
        currency,
        loadOrderDetails,
        refreshEvents,
        card_logo_url
    } = props;
    const [refundOption, setRefundOption] = useState<'refund' | 'no-refund'>('refund');
    const [cancelReason, setCancelReason] = useState<string>('');


    const submitCancelOrder = (refundOption: 'refund' | 'no-refund') => {
        ApiRequest({
            url: '/orders/cancel',
            method: 'POST',
            body: {
                order_id: order_id,
                refund_option: refundOption,
                cancel_reason: cancelReason
            },
            setResponse: (response: any) => {
                setOpen(false);
                loadOrderDetails();
                if (refreshEvents) {
                    refreshEvents();
                }
            }
        });
    }

    const formatPrice = (price: number | string, curr: string = 'CAD') => {
        const formattedNumber = Number(price).toLocaleString('en-CA', { 
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2 
        });
        return `$${formattedNumber} ${curr}`;
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
        >
            <DialogContent style={{ padding: '0', maxWidth: '530px' }}>
                <div className="cancel_dialog_content" style={{ padding: '27px'}}>
                    <div className="cancel_dialog_header">
                        <Avatar sx={{ bgcolor: '#FCF2F2', width: 40, height: 40 }}>
                            <PiTrash color="#CA3A31" size={20} />
                        </Avatar>
                        <h3 className='heading_h3_dialog'>Canceling Order #{order_id}</h3>
                    </div>

                    <div className="transfer_dialog_warning">
                        <PiWarningCircleFill size={14} />
                        Warning This action is not reversible, please be certain.
                    </div>



                    <div style={{ marginBottom: '20px' }}>
                        <h4 style={{ fontWeight: '400', fontSize: '14px', marginBottom: '15px', color: '#424242' }}>
                            Refund Options
                        </h4>

                        <Box
                            onClick={() => setRefundOption('refund')}
                            sx={{
                                border: '1px solid #ECEBFF',
                                borderRadius: '8px',
                                padding: '16px',
                                marginBottom: '12px',
                                cursor: 'pointer',
                                backgroundColor: refundOption === 'refund' ? '#F8F7FF' : 'white',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                            }}
                        >
                            {refundOption === 'refund' ? (
                                <PiCheckCircleFill size={20} color="#7963FF" />
                            ) : (
                                <PiCircle size={20} color="#B9B9B9" />
                            )}
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: '14px', fontWeight: '500', color: '#424242', marginBottom: '4px' }}>
                                    Cancel And Refund To Original Payment Method
                                </div>
                                <div style={{ fontSize: '14px', color: '#666666' }}>
                                    Refund {formatPrice(total_price || '0.00', currency || 'CAD')}
                                </div>
                            </div>

                            <div className="card_logo_container">
                                {card_logo_url && (
                                    <img src={card_logo_url} style={{ width: '30px', height: '20px', objectFit: 'contain' }} />
                                )}
                            </div>
                        </Box>

                        <Box
                            onClick={() => setRefundOption('no-refund')}
                            sx={{
                                border: '1px solid #ECEBFF',
                                borderRadius: '8px',
                                padding: '16px',
                                cursor: 'pointer',
                                backgroundColor: refundOption === 'no-refund' ? '#F8F7FF' : 'white',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                '&:hover': {
                                    backgroundColor: '#F9F9FC',
                                }
                            }}
                        >
                            {refundOption === 'no-refund' ? (
                                <PiCheckCircleFill size={20} color="#7963FF" />
                            ) : (
                                <PiCircle size={20} color="#B9B9B9" />
                            )}
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: '14px', fontWeight: '500', color: '#424242', marginBottom: '4px' }}>
                                    Cancel Without Refund
                                </div>
                                <div style={{ fontSize: '14px', color: '#666666' }}>
                                    This Will Cancel The Order, But No Money Will Be Refunded.
                                </div>
                            </div>
                        </Box>
                    </div>
                </div>

                <div className="cancel_reason_container" style={{ marginBottom: '20px' }}>
                    <h4 style={{ fontWeight: '400', fontSize: '14px', marginBottom: '8px', color: '#424242' }}>
                        Reason For Cancellation
                    </h4>
                    <TextField
                        fullWidth
                        multiline
                        placeholder="Enter reason for cancellation"
                        value={cancelReason}
                        onChange={(e) => setCancelReason(e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                padding: '0',
                                backgroundColor: '#FFFFFF',
                            }
                        }}
                    />
                </div>

                <div className="cancel_dialog_actions">
                    <Button
                        variant="text"
                        color="primary"
                        onClick={() => setOpen(false)}
                        sx={{
                            borderColor: '#B9B9B9',
                            borderRadius: '5px !important',
                            color: '#424242',
                            padding: '6px 10px !important',
                            marginRight: '10px'
                        }}
                    >
                        Keep Order
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={() => submitCancelOrder(refundOption)}
                        loading={loading}
                        sx={{
                            borderRadius: '5px !important',
                            padding: '6px 10px !important',
                            backgroundColor: '#BD2B2B',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#BD2B2B'
                            }
                        }}
                    >
                        Cancel Order
                    </LoadingButton>
                </div>
            </DialogContent>
        </Dialog>
    )
}